import React from 'react';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { get } from 'lodash';
import { makeStyles } from '@material-ui/styles';
import styles from './styles';
import { GenericFormFields } from '../interfaces';

const useStyles = makeStyles(styles);

const GenericFormCheckbox: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  const classes = useStyles({ fontSize: item.fontSize });

  const showError = () => {
    if (!!get(errors, item.error, null))
      return <FormHelperText>{get(errors, item.error, null)}</FormHelperText>;
    if (!!get(errors, item.stateKey, null))
      return (
        <FormHelperText>{get(errors, item.stateKey, null)}</FormHelperText>
      );
    return null;
  };

  return (
    <FormControl
      fullWidth
      error={
        !!get(errors, item.stateKey, null) || get(errors, item.error, null)
      }
    >
      <FormGroup row>
        <FormControlLabel
          key={item.stateKey}
          disabled={item.disabled}
          control={
            <Checkbox
              checked={
                fields
                  ? get(fields, item.stateKey, null)
                  : get(values, item.stateKey, null)
              }
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (setFieldValue)
                  setFieldValue(item.stateKey, e.target.checked);
                if (changeField)
                  changeField({
                    key: item.stateKey,
                    value: e.target.checked,
                  });
              }}
              value={fields ? fields[item.stateKey] : values[item.stateKey]}
            />
          }
          label={
            <Typography className={classes.checkboxLabel}>
              {item.label}
            </Typography>
          }
        />
      </FormGroup>
      {showError()}
    </FormControl>
  );
};

export default GenericFormCheckbox;
